import { useMemo } from 'react'
import { Link, Text } from "@ds/react";
import Form from "components/Form";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import { cpf, required, validBirthdate } from "utils/form/validations";
import { ReactComponent as InformationIcon } from "assets/icons/information.svg";
import * as S from "../FormDados.style";
import { useState } from "react";
import UsoDadosModal from "./UsoDadosModal";
import masks from "utils/form/masks";

import OptionSelector from 'components/OptionSelector'

const genderOptions = [
  { id: "M", value: "Masculino" },
  { id: "F", value: "Feminino" },
];

const DadosPessoais = ({ validationRef, initialValue }) => {
  const [showModal, setShowModal] = useState(false);
  const [nomeSocialOption, setNomeSocialOption] = useState('')

  const socialName = useMemo(() => {
    const rawContext = sessionStorage.getItem("CONTEXT")
    const parsedContext = JSON.parse(rawContext)
    const nomeSocial = parsedContext?.personalData?.dadosPessoais?.nomeSocial || ""

    if (!nomeSocial) return ""

    setNomeSocialOption('Sim')

    return nomeSocial
  }, [])

  return (
    <section>
      <Section>
        <ResponsiveCard
          maxContent
          title="Dados pessoais"
          description={
            <>
              <Text variant="body-02-sm">
                Agora, vamos precisar dos seus dados pessoais para concluir a sua compra. Eles serão
                usados para te identificar ou para entrar em contato, caso necessário.
              </Text>
              <S.Container className="link">
                <InformationIcon />
                <Link variant="primary-sm-01" onClick={() => setShowModal(true)}>
                  Saiba mais sobre o uso dos seus dados
                </Link>
              </S.Container>
            </>
          }
        >
          <Form.Section validationRef={validationRef} scheme={initialValue}>
            <Form.Input
              name="nome"
              label="Nome completo"
              placeholder="Sem abreviar, ok?"
              validationRules={[required]}
              mask={masks.name}
            />
            <Form.Input
              name="cpf"
              label="CPF"
              placeholder="Apenas números"
              validationRules={[required, cpf]}
              half
              mask={masks.cpf}
            />
            
            <OptionSelector
              fnSelectedOption={setNomeSocialOption}
              options={['Sim', 'Não']}
              label='Deseja informar um nome social?'
              initialState={socialName.trim() ? "Sim" : ""}
            />

            {nomeSocialOption.toLocaleLowerCase().includes('sim') && (
              <Form.Input
                name="nomeSocial"
                label="Nome Social"
                placeholder="Nome Social"
                validationRules={[required]}
                mask={masks.name}
              />
            )}
 
            <Form.Input
              name="dataNascimento"
              label="Data de nascimento"
              placeholder="DD/MM/AAAA"
              validationRules={[required, validBirthdate]}
              half
              mask={masks.date}
            />
            <Form.RadioButtons
              name="sexo"
              label="Gênero, conforme documento de identificação"
              validationRules={[required]}
              half
              options={genderOptions}
            />
          </Form.Section>
        </ResponsiveCard>
        <UsoDadosModal open={showModal} onClose={() => setShowModal(false)} />
      </Section>
    </section>
  );
};

export default DadosPessoais;
